import {BaseModel} from '../baseModel';
import {Partner} from '../res/partner';
import {Company} from '../res/company';
import {Currency} from '../res/currency';
import {InvoiceLine} from './invoice-line';

/**
 * Invoice
 */
export class Invoice extends BaseModel<number> {
  date?: string;
  number?: string;
  ref?: string;
  origin?: string;
  type?: string; // type of invoice (enum.)
  state?: string; // state of invoice (enum.)
  dateDue?: string;
  tolerance?: string;
  partner?: Partner;
  commercialPartner?: Partner;
  company?: Company;
  currency?: Currency;
  amountUntaxed?: number;
  amountTax?: number;
  amountTotal?: number;
  amountTotalBeforeDiscount?: number;
  additionOfServices?: boolean;
  amountResidual?: number;
  amountToPay?: number;
  creditAmount?: number;
  description?: string;
  lines?: InvoiceLine[];
  discount?: any;
  memo?: string;
  externalId?: any;
  fullDiscount?: boolean;
  name?: any;
  hasProcessingFee?: boolean;
  processingFee?: number;
}
